import React from 'react';
// eslint-disable-next-line
import { Input, Table } from 'antd';
// eslint-disable-next-line
import { FilterOutlined } from '@ant-design/icons';

//import { SMART_PO_RECV_LIST_REQ_SIZE } from 'constants/config';
import { poStatusMap } from 'constants/enums';

type Props = {
  getPoList?: Function;
  height?: number;
  onSelectPo?: Function;
  poList: StringKAnyVPair[];
  total?: number;
};

const PoListView = (props: Props) => {
  const { useRef, useState } = React;
  const [poTotal, setPoTotal] = useState(props.total || props.poList.length);
  const bottomCellRef = useRef<any>(null);
  const lastRowRef = useRef<any>(null);
  const listIsLoadable = useRef<any>(true);
  const listIsLoading = useRef<any>(false);

  const columns = [
    {
      title: 'PO#',
      dataIndex: 'poNumber',
    },
    /*{
      title: 'PO Warehouse',
      dataIndex: 'warehouseCode',
    },*/
    {
      title: 'Supplier',
      dataIndex: 'vendorName',
      render(text: string, row: StringKAnyVPair, idx: number) {
        const isObservable = isRowObservable(idx);
        const observer = new IntersectionObserver(
          ([entry]) => { if (!listIsLoading.current && entry.isIntersecting) loadPageList(); },
          { threshold: 1.0 } // 1.0 means the entire sentinel must be visible
        );

        if (isObservable && bottomCellRef.current) observer.observe(bottomCellRef.current);

        return isObservable ? (<>
          <span>{text}</span>
          <div ref={bottomCellRef} style={{ height: 40 }} />
        </>) : text;
      },
    },
    {
      title: 'PO Status',
      render(row: any) {
        //return poControlStatus[`${row.controlStatus}`] || '';
        return poStatusMap[row.poStatusNum] || '';
      },
    },
  ];

  const getRowBgColor = (row: StringKAnyVPair) => {
    let bgColor: string | undefined = undefined;

    switch(row.poStatusNum) {
      case 2:
        bgColor = '#E6F7FF';
        break;

      case 3:
        bgColor = '#F6FFED';
        break;

      case 4:
        bgColor = '#FFFBE6';
        break;
    }

    return bgColor;
  };

  const isRowObservable = (idx: number) => {
    const listLength = props.poList.length;

    //return listIsLoadable.current && listLength >= SMART_PO_RECV_LIST_REQ_SIZE && listLength % SMART_PO_RECV_LIST_REQ_SIZE === 0 && idx === props.poList.length - 1;
    return listIsLoadable.current && listLength < poTotal && idx === props.poList.length - 1;
  };

  const listRowProps = (row: StringKAnyVPair, idx: any) => {
    const p = {
      //id: `po-${idx}`,
      onClick: () => onRowClick(row),
      style: {
        backgroundColor: getRowBgColor(row),
      },
    };

    if (idx === props.poList.length - 1) {
      //console.log('idx', row, idx);
      // @ts-ignore
      p.ref = lastRowRef;
      //setListVersion(listVersion + 1);
    }

    return p;
  };

  const loadPageList = async () => {
    listIsLoading.current = true;

    if (props.getPoList) {
      const pos = await props.getPoList();
      //console.log('pos', pos);
      listIsLoadable.current = Array.isArray(pos) && pos.length > 0;
    }

    listIsLoading.current = false;
  };

  const onRowClick = (record: StringKAnyVPair) => {
    //console.log('re', record);
    if (props.onSelectPo) props.onSelectPo(record);
  };

  const tableScrollHeight = () => {
    if (props.height) {
      const h = props.height - 92 - 20;

      return h > 0 ? h : 0;
    }
  };

  React.useEffect(() => {
    if (props.total && props.total !== poTotal) {
      setPoTotal(props.total);
    }
  }, [poTotal, props]);

  return (<div>
    {/*<div style={{marginBottom: 12}}>
      <Input
        placeholder="Filter"
        prefix={<FilterOutlined />}
        size="large"
      />
    </div>*/}
    <Table
      columns={columns}
      dataSource={props.poList}
      onRow={listRowProps}
      pagination={false}
      rowKey="poNum"
      scroll={{y: tableScrollHeight()}}
      size="middle"
    />
  </div>);
};

export default PoListView;
